module.exports = __webpack_public_path__ + "static/media/wewce.cd3ad689.jpg";